export default __webpack_public_path__ + "static/media/React.80045de7.png";